/* =========================================================
   DOSSIER — theme.js  (geen externe libraries)
   ========================================================= */
(function () {
  'use strict';

  var body = document.body;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mo = body.classList.contains('mo') && !reduced;

  /* ---------- 1. Woordmerk letter voor letter ---------- */
  function wordmarks() {
    document.querySelectorAll('[data-wm]').forEach(function (el) {
      var text = el.textContent.trim();
      el.textContent = '';
      text.split('').forEach(function (ch, i) {
        var s = document.createElement('span');
        s.textContent = ch === ' ' ? '\u00A0' : ch;
        s.style.transitionDelay = (i * 45) + 'ms';
        el.appendChild(s);
      });
      if (!mo) { el.classList.add('on'); return; }
      requestAnimationFrame(function () {
        setTimeout(function () { el.classList.add('on'); }, 120);
      });
    });
  }

  /* ---------- 2. Elementen tonen bij binnenkomst ---------- */
  function reveals() {
    var items = document.querySelectorAll('[data-up]');
    if (!mo || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('on');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    items.forEach(function (el, i) {
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(el);
    });
  }

  /* ---------- 3. Menu-overlay ---------- */
  function overlay() {
    var ov = document.querySelector('[data-ov]');
    var open = document.querySelector('[data-ov-open]');
    var close = document.querySelector('[data-ov-close]');
    if (!ov || !open) return;
    function set(on) {
      ov.classList.toggle('open', on);
      document.body.style.overflow = on ? 'hidden' : '';
      open.setAttribute('aria-expanded', String(on));
      if (on) { var f = ov.querySelector('a'); if (f) f.focus(); }
    }
    open.addEventListener('click', function () { set(true); });
    if (close) close.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    ov.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { set(false); });
    });
  }

  /* ---------- 4. Ticker verdubbelen voor naadloos lopen ---------- */
  function tickers() {
    document.querySelectorAll('[data-tk]').forEach(function (row) {
      row.innerHTML = row.innerHTML + row.innerHTML;
    });
  }

  /* ---------- 5. Zwevende voorvertoning bij de index ---------- */
  function floatPreview() {
    var box = document.querySelector('[data-float]');
    var img = document.querySelector('[data-float-img]');
    var rows = document.querySelectorAll('[data-shot]');
    if (!box || !img || !rows.length) return;
    if (!window.matchMedia('(pointer:fine)').matches) return;

    var x = 0, y = 0, cx = 0, cy = 0, active = false, raf = null;

    function loop() {
      cx += (x - cx) * 0.14;
      cy += (y - cy) * 0.14;
      box.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px) translate(-50%,-50%)' + (active ? ' scale(1)' : ' scale(.94)');
      raf = requestAnimationFrame(loop);
    }

    document.addEventListener('mousemove', function (e) { x = e.clientX; y = e.clientY; });

    rows.forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        var src = row.getAttribute('data-shot');
        if (!src) return;
        img.src = src;
        active = true;
        box.classList.add('on');
        if (!raf) { cx = x; cy = y; loop(); }
      });
      row.addEventListener('mouseleave', function () {
        active = false;
        box.classList.remove('on');
      });
    });
  }

  /* ---------- 6. Horizontale rail: slepen en knoppen ---------- */
  function rails() {
    document.querySelectorAll('[data-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-track]');
      if (!track) return;
      var prev = rail.querySelector('[data-prev]');
      var next = rail.querySelector('[data-next]');

      function step() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width + 24 : 300;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      var down = false, startX = 0, startLeft = 0, moved = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = 0;
        startX = e.clientX;
        startLeft = track.scrollLeft;
        track.classList.add('drag');
      });
      window.addEventListener('pointerup', function () {
        down = false;
        track.classList.remove('drag');
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var d = e.clientX - startX;
        moved = Math.abs(d);
        track.scrollLeft = startLeft - d;
      });
      track.addEventListener('click', function (e) {
        if (moved > 8) { e.preventDefault(); }
      }, true);
    });
  }

  /* ---------- 7. Accordeon ---------- */
  function accordions() {
    document.querySelectorAll('[data-ac]').forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function once() {
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', once);
          });
        }
      });
    });
  }

  /* ---------- 8. Voorbeeldpagina vergroten ---------- */
  function lightbox() {
    var box = document.querySelector('[data-lb]');
    var img = document.querySelector('[data-lb-img]');
    if (!box || !img) return;
    function shut() { box.hidden = true; document.body.style.overflow = ''; }
    document.querySelectorAll('[data-peek]').forEach(function (b) {
      b.addEventListener('click', function () {
        img.src = b.getAttribute('data-peek');
        box.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
    box.addEventListener('click', function (e) { if (e.target !== img) shut(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  }

  /* ---------- 9. Sorteren ---------- */
  function sorting() {
    var sel = document.querySelector('[data-sort]');
    if (sel) sel.addEventListener('change', function () { sel.form.submit(); });
  }

  /* ---------- 10. Winkelwagen ---------- */
  function toast(msg) {
    var box = document.querySelector('[data-toast]');
    var slot = document.querySelector('[data-toast-msg]');
    if (!box || !slot) return;
    slot.textContent = msg;
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('on'); });
    clearTimeout(box._t);
    box._t = setTimeout(function () {
      box.classList.remove('on');
      setTimeout(function () { box.hidden = true; }, 600);
    }, 4200);
  }

  function addToCart() {
    var form = document.querySelector('[data-add]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Bezig'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status) throw new Error('nope');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-count]').forEach(function (el) { el.textContent = cart.item_count; });
          toast('In je winkelwagen.');
        })
        .catch(function () { toast('Dat lukte niet. Probeer het opnieuw.'); })
        .finally(function () {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
        });
    });
  }


  /* ---------------------------------------------------------
     12. Openingsgordijn (homepage, één keer per sessie)
     --------------------------------------------------------- */
  function curtain() {
    var c = document.querySelector('[data-curtain]');
    if (!c) return;
    if (!mo) { c.remove(); return; }

    var seen = false;
    try { seen = sessionStorage.getItem('dossier-intro') === '1'; } catch (e) { seen = false; }
    if (seen) { c.remove(); return; }

    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { c.classList.add('lit'); });
    setTimeout(function () {
      c.classList.add('gone');
      document.body.style.overflow = '';
      try { sessionStorage.setItem('dossier-intro', '1'); } catch (e) {}
      setTimeout(function () { if (c.parentNode) c.remove(); }, 1200);
    }, 1500);
  }

  /* ---------------------------------------------------------
     13. Koppen woord voor woord
     --------------------------------------------------------- */
  function splitHeadings() {
    if (!mo || body.getAttribute('data-split') !== 'true') return;
    var targets = document.querySelectorAll('h1.dp, h2.dp, .quote__t, .ix__t');
    targets.forEach(function (el) {
      if (el.classList.contains('wm') || el.querySelector('.wsp')) return;
      var frag = document.createDocumentFragment();
      (function walk(node, out, it) {
        Array.prototype.forEach.call(node.childNodes, function (c) {
          if (c.nodeType === 3) {
            c.textContent.split(/(\s+)/).forEach(function (chunk) {
              if (!chunk.trim()) { out.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span');
              w.className = 'wsp';
              if (it) { var em = document.createElement('em'); em.textContent = chunk; w.appendChild(em); }
              else { w.textContent = chunk; }
              out.appendChild(w);
            });
          } else if (c.nodeName === 'BR') {
            out.appendChild(document.createElement('br'));
          } else if (c.nodeName === 'SPAN' && c.className) {
            out.appendChild(c.cloneNode(true));
          } else {
            walk(c, out, it || c.nodeName === 'EM' || c.nodeName === 'I');
          }
        });
      })(el, frag, false);
      el.textContent = '';
      el.appendChild(frag);
      var words = el.querySelectorAll('.wsp');
      words.forEach(function (w, i) { w.style.transitionDelay = (i * 42) + 'ms'; });

      if (!('IntersectionObserver' in window)) {
        words.forEach(function (w) { w.classList.add('on'); });
        return;
      }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          words.forEach(function (w) { w.classList.add('on'); });
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      io.observe(el);
    });
  }

  /* ---------------------------------------------------------
     14. Beeld met gordijnonthulling
     --------------------------------------------------------- */
  function maskImages() {
    if (!mo || body.getAttribute('data-mask') !== 'true') return;
    var imgs = document.querySelectorAll('.card__cover img, .cover img, .lead__img img, .split__media img, .featured__media img, .post img');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('on');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    imgs.forEach(function (img) {
      img.classList.add('mk-img');
      io.observe(img);
    });
  }

  /* ---------------------------------------------------------
     15. Knoppen veren mee met de muis (max 8px)
     --------------------------------------------------------- */
  function magnets() {
    if (!mo || body.getAttribute('data-magnet') !== 'true') return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('.btn').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        el.style.transform = 'translate(' + (dx * 8).toFixed(1) + 'px,' + (dy * 8).toFixed(1) + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------------------------------------------------------
     16. Lichte parallax
     --------------------------------------------------------- */
  function parallax() {
    if (!mo || body.getAttribute('data-parallax') !== 'true') return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('.op__shot .cover img, .lead__img .cover img'));
    if (!items.length) return;
    var tick = false;
    function paint() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.translate = '0 ' + (mid * -0.045).toFixed(2) + 'px';
      });
      tick = false;
    }
    window.addEventListener('scroll', function () {
      if (!tick) { requestAnimationFrame(paint); tick = true; }
    }, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  }

  /* ---------------------------------------------------------
     17. Lopende band versnelt bij scrollen
     --------------------------------------------------------- */
  function tickerBoost() {
    if (!mo || body.getAttribute('data-boost') !== 'true') return;
    var bands = document.querySelectorAll('.tk');
    if (!bands.length) return;
    var last = window.scrollY, timer = null;
    window.addEventListener('scroll', function () {
      var d = Math.abs(window.scrollY - last);
      last = window.scrollY;
      if (d < 6) return;
      bands.forEach(function (b) { b.classList.add('boost'); });
      clearTimeout(timer);
      timer = setTimeout(function () {
        bands.forEach(function (b) { b.classList.remove('boost'); });
      }, 420);
    }, { passive: true });
  }

  /* ---------------------------------------------------------
     18. Zachte overgang tussen pagina's
     --------------------------------------------------------- */
  function pageFade() {
    var veil = document.querySelector('[data-veil]');
    if (!veil || !mo || body.getAttribute('data-fade') !== 'true') return;

    window.addEventListener('pageshow', function () { veil.classList.remove('up'); });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.getAttribute('rel') === 'external') return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (a.origin !== window.location.origin) return;
      if (href.indexOf('/cart/') === 0 || href.indexOf('/checkout') === 0) return;
      if (a.href === window.location.href) return;

      e.preventDefault();
      veil.classList.add('up');
      setTimeout(function () { window.location.href = a.href; }, 300);
    });
  }

  function boot() {
    wordmarks();
    reveals();
    overlay();
    tickers();
    floatPreview();
    rails();
    accordions();
    lightbox();
    sorting();
    addToCart();
    curtain();
    splitHeadings();
    maskImages();
    magnets();
    parallax();
    tickerBoost();
    pageFade();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(boot).catch(boot);
  } else {
    boot();
  }
})();
